import axios from "axios";
import { appConfig } from "../configs";
import { Routes } from "../constants";

function generateCodeVerifier() {
  const array = new Uint32Array(56);
  window.crypto.getRandomValues(array);
  return Array.from(array, (dec) => dec.toString(36))
    .join("")
    .slice(0, 128);
}
const generateCodeChallenge = (codeVerifier: string) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(codeVerifier);
  return window.crypto.subtle.digest("SHA-256", data).then((hash) => {
    const hashArray = new Uint8Array(hash);

    return btoa(String.fromCharCode(...Array.from(hashArray)))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  });
};

export const fetchGetOauthToken = async (code: string) => {
  try {
    const code_verifier = localStorage.getItem("code_verifier") ?? "";
    const response = await axios.post(`${appConfig.API_URL}/oauth/token`, {
      grant_type: "authorization_code",
      client_id: appConfig.SPA_CLIENT_ID,
      code: code,
      code_verifier: code_verifier,
      redirect_uri: `${window.location.origin}${Routes.USER}`,
      audience: appConfig.AUTH0_AUDIENCE,
      scope: "openid profile email offline_access read:users read:current_user",
    });
    return response.data;
  } catch (err) {
    throw err;
  } finally {
  }
};

export const fetchGetAuthorize = async (
  screen_hint: "signup" | "login" = "login",
  prompt: boolean = true,
  connection:string =''
) => {
  const code_verifier = generateCodeVerifier();
  generateCodeChallenge(code_verifier).then((codeChallenge) => {
    localStorage.setItem("code_verifier", code_verifier);
    const authUrl = `${
      appConfig.API_URL
    }/authorize?response_type=code&client_id=${
      appConfig.SPA_CLIENT_ID
    }&redirect_uri=${`${window.location.origin}${Routes.USER}`}&scope=openid profile email offline_access read:users read:current_user update:current_user_metadata&code_challenge=${codeChallenge}&code_challenge_method=S256&audience=${
      appConfig.AUTH0_AUDIENCE
    }${prompt ? "&prompt=login" : ""}${connection ? `&connection=${connection}` : ""}`;
    window.location.href = `${authUrl}&screen_hint=${screen_hint}`;
  });
};

export const fetchGetNewToken = async (refresh_token: string) => {
  try {
    const response = await axios.post(`${appConfig.PROXY_API_URL}/refresh`, {
      refresh_token
    });
    return response.data;
  } catch (err) {
    throw err;
  } finally {
  }
};

export const fetchGetNewTokenSpa = async (refresh_token: string) => {
  try {
    const response = await axios.post(`${appConfig.API_URL}/oauth/token`, {
      grant_type: "refresh_token",
      client_id: appConfig.SPA_CLIENT_ID,
      refresh_token,
    })
    return response.data;
  } catch (err) {
    throw err;
  } finally {
  }
};
